














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Pencetus extends Vue {
  @Prop() setPencetus: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  // pencetus = null;

  // @Watch("pencetus")
  // changePencetus(val) {
  //   this.$emit("pencetus", val);
  // }

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setPencetus == "" || this.setPencetus == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setPencetus")
  valPencetus(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("pencetus", val);
    this.setPencetus = val;
  }
}
